import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../context/AuthContext';

const PrivateRoute = ({ allowedRoles = [], children }) => {
  const { isAuthenticated, userInfo, loading } = useAuth();



  if (loading) {

    return <div>Loading...</div>; // Wacht tot de auth-status bekend is
  }

  if (!isAuthenticated) {
    console.warn("User is not authenticated, redirecting to login.");
    return <Navigate to="/login" replace />;
  }

  if (!userInfo || !userInfo.role) {
    console.warn("User role is not defined, redirecting to login.");
    return <Navigate to="/login" replace />;
  }

  
  // if (roles.includes(userInfo.role)) {
  //   console.warn("User role is geautoriseerd to /notfound.");
  //   return <Navigate to="/notfound" replace />;
  // }

  if (!allowedRoles.includes(userInfo.role)) {
    console.warn(`User role (${userInfo.role}) is not authorized, redirecting to /notfound.`);
    return <Navigate to="/notauthorized" replace />;
  }

  return children;
};

export default PrivateRoute;
